import { Component } from '@angular/core';

@Component({
  templateUrl: 'viewreporequest.component.html'
})
export class ViewreporequestComponent {

  constructor() { 

  } 
}


// WEBPACK FOOTER //
// ./src/app/repoagencies/viewreporequest.component.ts